var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49984 17.5833C1.49984 18.775 2.47484 19.75 3.6665 19.75H12.3332C13.5248 19.75 14.4998 18.775 14.4998 17.5833V4.58333H1.49984V17.5833ZM3.6665 6.75H12.3332V17.5833H3.6665V6.75ZM11.7915 1.33333L10.7082 0.25H5.2915L4.20817 1.33333H0.416504V3.5H15.5832V1.33333H11.7915Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconWhite);
export default __webpack_public_path__ + "static/media/delete-icon-white.4a1a08497f660951bd2f9b1886338364.svg";
export { ForwardRef as ReactComponent };